__turbopack_context__.v({
  "container": "aY82Ea_container",
  "strong": "aY82Ea_strong",
});
